export enum SyncManagerEvents {
	CHANGE_USER = 'CHANGE_USER_SYNC_EVENT',
	NEXT_PAGE = 'NEXT_PAGE_SYNC_EVENT',
	FORCE_SYNC = 'FORCE_SYNC',			// Force sync even if recently synced already (used when updating notifications)
	REQUEST_SYNC = 'REQUEST_SYNC',
    RESET_DATA = 'RESET_DATA',
}

export enum ServiceWorkerEvents {
	NOTIFICATION_UPDATE = 'NOTIFICATION_UPDATE_SERVICE_EVENT',
	TOAST_UPDATE = 'TOAST_UPDATE',
	LOGOUT = 'LOGOUT',
	USER_AUTHENTICATED = 'USER_AUTHENTICATED',
	USER_AUTHORIZATION_ERROR = 'USER_AUTHORIZATION_ERROR'
}

export enum ServiceWorkerCommand {
	LOGGING_UPDATE = 'LOGGING_UPDATE'
}